<template>
  <div
    v-if="!isOnlySpecialShippingMethod && !(noShippingChoices && !isCustomerOrder)"
    class="shipping-method__selected flex flex-col font-medium leading-3 md:flex-row lg:flex-col xl:flex-row lg-max:items-center"
  >
    <span class="leading-6">{{ checkoutShipment?.shipmentMethodOption }} </span>
    <div class="flex flex-col md:flex-row lg:flex-col xl:flex-row xl:items-center">
      <template v-if="checkoutShipment?.businessDaysToShipTL">
        <span class="hidden self-center px-2 leading-3 text-[--color-neutral-a4] md:flex lg:hidden xl:flex">|</span>
        <span class="leading-6">
          {{ checkoutShipment.businessDaysToShipTL }}
        </span>
      </template>
      <span class="hidden self-center px-2 leading-3 text-[--color-neutral-a4] md:flex lg:hidden xl:flex">|</span>
      <span v-if="checkoutShipment?.shippingAccountNumberTL" class="leading-6"
        >{{ $t("common.titles.account_text") }}: {{ checkoutShipment?.shippingAccountNumberTL }}</span
      >
      <span v-else class="leading-6">
        <VcPriceDisplay :formatted-value="formatPrice(checkoutShipment?.shipmentPriceAmount, currentCurrency)">
        </VcPriceDisplay>
      </span>
    </div>
  </div>
  <div v-else>
    <span class="leading-6">{{ $t("shared.checkout.quote_shipping_method_review") }}</span>
  </div>
</template>

<script setup lang="ts">
import { useCurrency } from "@/core/composables";
import { formatPrice } from "@/shared/cart/utils/formatPrice";
import { useCheckoutFacade } from "../../composables/useCheckoutFacade";

interface IProps {
  isOnlySpecialShippingMethod: boolean;
  noShippingChoices: boolean;
}

defineProps<IProps>();

const { currentCurrency } = useCurrency();
const { checkoutShipment, isCustomerOrder } = useCheckoutFacade();
</script>

<style lang="scss">
.shipping-method {
  &__selected {
    span {
      @apply relative;

      &::after {
        @apply bg-[--color-neutral-a4] pr-4 h-[15px] w-[1px];
      }
    }
  }
}

.vc-tooltip__description {
  a {
    @apply text-[--link-color];
  }
}
</style>
